import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { DateFormat } from '@models/date-format';
const defaultFormat = DateFormat.dateOnly;
@Pipe({
    name: 'dateFormat',
    standalone: true,
})
export class dateFormatPipe implements PipeTransform {
    transform(
        value: Date | string | null | undefined,
        format: string = defaultFormat,
        timezone: string = 'utc'
    ): string | null {
        if (!value) {
            return null;
        }
        return new DatePipe('en-US').transform(value, format, timezone, 'en-US');
    }
}
